import React, { useState } from 'react';
import one from '../../assest/project.png';
import { FaMapMarkerAlt, FaUserTie, FaCalendarAlt, FaClock, FaHardHat, FaBuilding } from 'react-icons/fa';
import { useSelector } from 'react-redux';

// Translation objects
const translations = {
  gb: {
    title: "Our Ongoing Projects",
    subtitle: "Delivering excellence in infrastructure development across the Kingdom",
    viewDetails: "View Details",
    viewAll: "View All Ongoing Projects",
    progress: "Progress",
    client: "Client",
    timeline: "Timeline",
    duration: "Duration",
    location: "Location",
    scope: "Scope",
    budget: "Budget",
    complete: "Complete",
    close: "Close",
    requestInfo: "Request More Information",
    statuses: {
      onSchedule: "On Schedule",
      accelerated: "Accelerated",
      planning: "Planning Phase"
    }
  },
  sa: {
    title: "مشاريعنا الجارية",
    subtitle: "تقديم التميز في تطوير البنية التحتية في جميع أنحاء المملكة",
    viewDetails: "عرض التفاصيل",
    viewAll: "عرض جميع المشاريع الجارية",
    progress: "التقدم",
    client: "العميل",
    timeline: "الجدول الزمني",
    duration: "المدة",
    location: "الموقع",
    scope: "النطاق",
    budget: "الميزانية",
    complete: "مكتمل",
    close: "إغلاق",
    requestInfo: "طلب المزيد من المعلومات",
    statuses: {
      onSchedule: "وفقًا للجدول",
      accelerated: "متسارع",
      planning: "مرحلة التخطيط"
    }
  },
  fr: {
    title: "Nos Projets en Cours",
    subtitle: "Fournir l'excellence dans le développement des infrastructures à travers le Royaume",
    viewDetails: "Voir les Détails",
    viewAll: "Voir Tous les Projets en Cours",
    progress: "Progrès",
    client: "Client",
    timeline: "Calendrier",
    duration: "Durée",
    location: "Emplacement",
    scope: "Portée",
    budget: "Budget",
    complete: "Terminé",
    close: "Fermer",
    requestInfo: "Demande Plus d'Information",
    statuses: {
      onSchedule: "Selon le Calendrier",
      accelerated: "Accéléré",
      planning: "Phase de Planification"
    }
  },
  de: {
    title: "Unsere Laufenden Projekte",
    subtitle: "Exzellenz in der Infrastrukturentwicklung im gesamten Königreich",
    viewDetails: "Details Anzeigen",
    viewAll: "Alle Laufenden Projekte Anzeigen",
    progress: "Fortschritt",
    client: "Kunde",
    timeline: "Zeitplan",
    duration: "Dauer",
    location: "Standort",
    scope: "Umfang",
    budget: "Budget",
    complete: "Abgeschlossen",
    close: "Schließen",
    requestInfo: "Weitere Informationen Anfordern",
    statuses: {
      onSchedule: "Nach Zeitplan",
      accelerated: "Beschleunigt",
      planning: "Planungsphase"
    }
  }
};

const ongoingProjects = [
  {
    id: 1,
    image: one,
    title: {
      gb: 'Ministry of Health Upgrade',
      sa: 'ترقية وزارة الصحة',
      fr: 'Mise à niveau du Ministère de la Santé',
      de: 'Upgrade des Gesundheitsministeriums'
    },
    description: {
      gb: 'Comprehensive infrastructure modernization including full manpower deployment, state-of-the-art medical equipment installation, and facility upgrades across 12 hospitals in the region.',
      sa: 'التحديث الشامل للبنية التحتية بما في ذلك نشر القوى العاملة بالكامل وتركيب أحدث المعدات الطبية وترقية المرافق في 12 مستشفى في المنطقة.',
      fr: 'Modernisation complète des infrastructures comprenant le déploiement complet de la main-d\'œuvre, l\'installation d\'équipements médicaux de pointe et la modernisation des installations dans 12 hôpitaux de la région.',
      de: 'Umfassende Modernisierung der Infrastruktur einschließlich des vollständigen Personaleinsatzes, der Installation modernster medizinischer Geräte und der Modernisierung von Einrichtungen in 12 Krankenhäusern der Region.'
    },
    location: {
      gb: 'Riyadh, KSA',
      sa: 'الرياض، المملكة العربية السعودية',
      fr: 'Riyad, Arabie Saoudite',
      de: 'Riad, Saudi-Arabien'
    },
    client: {
      gb: 'Ministry of Health',
      sa: 'وزارة الصحة',
      fr: 'Ministère de la Santé',
      de: 'Gesundheitsministerium'
    },
    year: '2022 - Present',
    duration: {
      gb: '1 Year 6 Months',
      sa: 'سنة واحدة و 6 أشهر',
      fr: '1 an et 6 mois',
      de: '1 Jahr und 6 Monate'
    },
    progress: 75,
    status: 'onSchedule',
    budget: {
      gb: 'SAR 950M',
      sa: '950 مليون ريال سعودي',
      fr: '950 millions de SAR',
      de: '950 Mio. SAR'
    },
    scope: {
      gb: 'Healthcare Facilities',
      sa: 'مرافق الرعاية الصحية',
      fr: 'Établissements de santé',
      de: 'Gesundheitseinrichtungen'
    }
  },
  {
    id: 2,
    image: one,
    title: {
      gb: 'University Campus Expansion',
      sa: 'توسعة الحرم الجامعي',
      fr: 'Extension du Campus Universitaire',
      de: 'Erweiterung des Universitätsgeländes'
    },
    description: {
      gb: 'Construction of new academic buildings, research centers, and student facilities including a 5,000-seat auditorium and Olympic-sized swimming pool.',
      sa: 'بناء مبانٍ أكاديمية جديدة ومراكز بحثية ومرافق طلابية بما في ذلك قاعة تتسع لـ 5000 مقسم وحمام سباحة أوليمبي.',
      fr: 'Construction de nouveaux bâtiments universitaires, centres de recherche et installations pour étudiants comprenant un auditorium de 5 000 places et une piscine olympique.',
      de: 'Bau neuer akademischer Gebäude, Forschungszentren und Studenteneinrichtungen einschließlich eines 5.000 Sitzplätze umfassenden Auditoriums und eines olympischen Schwimmbeckens.'
    },
    location: {
      gb: 'Dammam, KSA',
      sa: 'الدمام، المملكة العربية السعودية',
      fr: 'Dammam, Arabie Saoudite',
      de: 'Dammam, Saudi-Arabien'
    },
    client: {
      gb: 'King Fahd University',
      sa: 'جامعة الملك فهد',
      fr: 'Université Roi Fahd',
      de: 'König-Fahd-Universität'
    },
    year: '2023 - Present',
    duration: {
      gb: '2 Years',
      sa: 'سنتين',
      fr: '2 ans',
      de: '2 Jahre'
    },
    progress: 40,
    status: 'onSchedule',
    budget: {
      gb: 'SAR 1.2B',
      sa: '1.2 مليار ريال سعودي',
      fr: '1,2 milliard de SAR',
      de: '1,2 Mrd. SAR'
    },
    scope: {
      gb: 'Education Infrastructure',
      sa: 'البنية التحتية التعليمية',
      fr: 'Infrastructure éducative',
      de: 'Bildungsinfrastruktur'
    }
  },
  {
    id: 3,
    image: one,
    title: {
      gb: 'Coastal Highway Development',
      sa: 'تطوير الطريق الساحلي',
      fr: 'Développement de l\'Autoroute Côtière',
      de: 'Küstenautobahn-Entwicklung'
    },
    description: {
      gb: 'Construction of 120km coastal highway with 8 interchanges, 3 tunnels, and 15 bridges connecting major port cities along the Red Sea coast.',
      sa: 'بناء طريق ساحلي بطول 120 كم مع 8 تقاطعات و3 أنفاق و15 جسرًا يربط بين المدن الساحلية الرئيسية على ساحل البحر الأحمر.',
      fr: 'Construction d\'une autoroute côtière de 120 km avec 8 échangeurs, 3 tunnels et 15 ponts reliant les principales villes portuaires le long de la côte de la mer Rouge.',
      de: 'Bau einer 120 km langen Küstenautobahn mit 8 Anschlussstellen, 3 Tunneln und 15 Brücken, die die wichtigsten Hafenstädte entlang der Küste des Roten Meeres verbindet.'
    },
    location: {
      gb: 'Jeddah to Yanbu, KSA',
      sa: 'من جدة إلى ينبع، المملكة العربية السعودية',
      fr: 'De Jeddah à Yanbu, Arabie Saoudite',
      de: 'Von Jeddah nach Yanbu, Saudi-Arabien'
    },
    client: {
      gb: 'Ministry of Transport',
      sa: 'وزارة النقل',
      fr: 'Ministère des Transports',
      de: 'Verkehrsministerium'
    },
    year: '2023 - Present',
    duration: {
      gb: '3 Years',
      sa: '3 سنوات',
      fr: '3 ans',
      de: '3 Jahre'
    },
    progress: 30,
    status: 'accelerated',
    budget: {
      gb: 'SAR 3.8B',
      sa: '3.8 مليار ريال سعودي',
      fr: '3,8 milliards de SAR',
      de: '3,8 Mrd. SAR'
    },
    scope: {
      gb: 'Transportation',
      sa: 'النقل',
      fr: 'Transport',
      de: 'Verkehr'
    }
  },
  {
    id: 4,
    image: one,
    title: {
      gb: 'Smart City Residential Complex',
      sa: 'مجمع سكني للمدينة الذكية',
      fr: 'Complexe Résidentiel de Ville Intelligente',
      de: 'Smart-City-Wohnkomplex'
    },
    description: {
      gb: 'Development of sustainable smart city housing for 5,000 families with integrated IoT solutions, solar power, and advanced waste management systems.',
      sa: 'تطوير سكن مستدام للمدينة الذكية لـ 5000 عائلة مع حلول إنترنت الأشياء المتكاملة والطاقة الشمسية وأنظمة إدارة النفايات المتقدمة.',
      fr: 'Développement de logements durables en ville intelligente pour 5 000 familles avec des solutions IoT intégrées, énergie solaire et systèmes avancés de gestion des déchets.',
      de: 'Entwicklung nachhaltiger Smart-City-Wohnungen für 5.000 Familien mit integrierten IoT-Lösungen, Solarenergie und fortschrittlichen Abfallmanagementsystemen.'
    },
    location: {
      gb: 'NEOM, KSA',
      sa: 'نيوم، المملكة العربية السعودية',
      fr: 'NEOM, Arabie Saoudite',
      de: 'NEOM, Saudi-Arabien'
    },
    client: {
      gb: 'NEOM Development Corporation',
      sa: 'شركة تطوير نيوم',
      fr: 'Société de Développement NEOM',
      de: 'NEOM-Entwicklungsgesellschaft'
    },
    year: '2024 - Present',
    duration: {
      gb: '4 Years',
      sa: '4 سنوات',
      fr: '4 ans',
      de: '4 Jahre'
    },
    progress: 15,
    status: 'planning',
    budget: {
      gb: 'SAR 2.5B',
      sa: '2.5 مليار ريال سعودي',
      fr: '2,5 milliards de SAR',
      de: '2,5 Mrd. SAR'
    },
    scope: {
      gb: 'Residential Development',
      sa: 'التطوير السكني',
      fr: 'Développement Résidentiel',
      de: 'Wohnungsbau'
    }
  },
  {
    id: 5,
    image: one,
    title: {
      gb: 'Industrial Zone Infrastructure',
      sa: 'بنية تحتية للمنطقة الصناعية',
      fr: 'Infrastructure de Zone Industrielle',
      de: 'Industriezonen-Infrastruktur'
    },
    description: {
      gb: 'Complete infrastructure development for new industrial zone including roads, utilities, warehouses and logistics centers across 8 square kilometers.',
      sa: 'تطوير بنية تحتية كاملة لمنطقة صناعية جديدة تشمل الطرق والمرافق والمستودعات ومراكز الخدمات اللوجستية عبر 8 كيلومترات مربعة.',
      fr: 'Développement complet des infrastructures pour une nouvelle zone industrielle comprenant des routes, des services publics, des entrepôts et des centres logistiques sur 8 kilomètres carrés.',
      de: 'Komplette Infrastrukturentwicklung für eine neue Industriezone mit Straßen, Versorgungseinrichtungen, Lagern und Logistikzentren auf 8 Quadratkilometern.'
    },
    location: {
      gb: 'Ras Al-Khair, KSA',
      sa: 'رأس الخير، المملكة العربية السعودية',
      fr: 'Ras Al-Khair, Arabie Saoudite',
      de: 'Ras Al-Khair, Saudi-Arabien'
    },
    client: {
      gb: 'Royal Commission',
      sa: 'الهيئة الملكية',
      fr: 'Commission Royale',
      de: 'Königliche Kommission'
    },
    year: '2022 - Present',
    duration: {
      gb: '2 Years 6 Months',
      sa: 'سنتين و 6 أشهر',
      fr: '2 ans et 6 mois',
      de: '2 Jahre und 6 Monate'
    },
    progress: 65,
    status: 'onSchedule',
    budget: {
      gb: 'SAR 1.8B',
      sa: '1.8 مليار ريال سعودي',
      fr: '1,8 milliard de SAR',
      de: '1,8 Mrd. SAR'
    },
    scope: {
      gb: 'Industrial Development',
      sa: 'التطوير الصناعي',
      fr: 'Développement Industriel',
      de: 'Industrielle Entwicklung'
    }
  },
  {
    id: 6,
    image: one,
    title: {
      gb: 'Heritage Site Restoration',
      sa: 'ترميم موقع التراث',
      fr: 'Restauration du Site Patrimonial',
      de: 'Restaurierung des Kulturerbestandorts'
    },
    description: {
      gb: 'Preservation and restoration of UNESCO-listed historical site including structural reinforcement and visitor center construction.',
      sa: 'الحفاظ على موقع تاريخي مدرج في اليونسكو وترميمه بما في ذلك التعزيز الهيكلي وبناء مركز الزوار.',
      fr: 'Préservation et restauration d\'un site historique classé par l\'UNESCO comprenant le renforcement structurel et la construction d\'un centre d\'accueil.',
      de: 'Erhaltung und Restaurierung einer UNESCO-gelisteten historischen Stätte einschließlich struktureller Verstärkung und Bau eines Besucherzentrums.'
    },
    location: {
      gb: 'Diriyah, KSA',
      sa: 'الدرعية، المملكة العربية السعودية',
      fr: 'Diriyah, Arabie Saoudite',
      de: 'Diriyah, Saudi-Arabien'
    },
    client: {
      gb: 'Diriyah Gate Authority',
      sa: 'هيئة بوابة الدرعية',
      fr: 'Autorité de la Porte de Diriyah',
      de: 'Diriyah-Tor-Behörde'
    },
    year: '2023 - Present',
    duration: {
      gb: '3 Years',
      sa: '3 سنوات',
      fr: '3 ans',
      de: '3 Jahre'
    },
    progress: 25,
    status: 'onSchedule',
    budget: {
      gb: 'SAR 750M',
      sa: '750 مليون ريال سعودي',
      fr: '750 millions de SAR',
      de: '750 Mio. SAR'
    },
    scope: {
      gb: 'Cultural Preservation',
      sa: 'الحفاظ الثقافي',
      fr: 'Préservation Culturelle',
      de: 'Kulturerhalt'
    }
  }
];

const Ongoing = () => {
  const { language } = useSelector((state) => state.language);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const t = translations[language] || translations['gb']; // Default to English if language not found

  const getStatusText = (status) => {
    switch(status) {
      case 'onSchedule': return t.statuses.onSchedule;
      case 'accelerated': return t.statuses.accelerated;
      case 'planning': return t.statuses.planning;
      default: return status;
    }
  };

  const handleViewDetails = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="text-danger fw-bold display-5">{t.title}</h2>
        <p className="lead text-muted">{t.subtitle}</p>
        <div className="d-flex justify-content-center">
          <div className="border-bottom border-danger border-3" style={{width: '100px'}}></div>
        </div>
      </div>

      <div className="row g-4">
        {ongoingProjects.map(project => (
          <div key={project.id} className="col-md-6 col-lg-4">
            <div className="card shadow-sm h-100 rounded-4 overflow-hidden border-0 hover-scale">
              <div className="position-relative">
                <img src={project.image} className="card-img-top" alt={project.title[language] || project.title['gb']} style={{height: '200px', objectFit: 'cover'}} />
                <div className="position-absolute top-0 end-0 bg-danger text-white px-3 py-1 rounded-bl">
                  {getStatusText(project.status)}
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title fw-bold text-dark">{project.title[language] || project.title['gb']}</h5>
                <p className="card-text text-muted mb-3">{project.description[language] || project.description['gb']}</p>
                
                <div className="mb-3">
                  <div className="d-flex justify-content-between small mb-1">
                    <span className="text-muted">{t.progress}</span>
                    <span className="fw-bold">{project.progress}%</span>
                  </div>
                  <div className="progress" style={{height: '6px'}}>
                    <div 
                      className={`progress-bar ${project.status === 'accelerated' ? 'bg-warning' : 'bg-danger'}`} 
                      role="progressbar" 
                      style={{width: `${project.progress}%`}}
                      aria-valuenow={project.progress} 
                      aria-valuemin="0" 
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                
                <ul className="list-unstyled small">
                  <li className="mb-2 d-flex align-items-center">
                    <FaMapMarkerAlt className="text-danger me-2" />
                    <span className="text-secondary">{project.location[language] || project.location['gb']}</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <FaUserTie className="text-danger me-2" />
                    <span className="text-secondary"><strong>{t.client}:</strong> {project.client[language] || project.client['gb']}</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <FaCalendarAlt className="text-danger me-2" />
                    <span className="text-secondary"><strong>{t.timeline}:</strong> {project.year}</span>
                  </li>
                  <li className="d-flex align-items-center">
                    <FaClock className="text-danger me-2" />
                    <span className="text-secondary"><strong>{t.duration}:</strong> {project.duration[language] || project.duration['gb']}</span>
                  </li>
                </ul>
              </div>
              <div className="card-footer bg-white border-0 pt-0 pb-3">
                <button 
                  className="btn btn-outline-danger btn-sm rounded-pill px-3"
                  onClick={() => handleViewDetails(project)}
                >
                  {t.viewDetails}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <button className="btn btn-danger px-4 py-2 rounded-pill">
          {t.viewAll}
        </button>
      </div>

      {/* Project Details Modal */}
      {showModal && selectedProject && (
        <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">{selectedProject.title[language] || selectedProject.title['gb']}</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <img src={selectedProject.image} className="img-fluid rounded mb-3" alt={selectedProject.title[language] || selectedProject.title['gb']} />
                    <p>{selectedProject.description[language] || selectedProject.description['gb']}</p>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item d-flex align-items-center">
                        <FaMapMarkerAlt className="text-danger me-3" />
                        <div>
                          <strong>{t.location}:</strong> {selectedProject.location[language] || selectedProject.location['gb']}
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center">
                        <FaUserTie className="text-danger me-3" />
                        <div>
                          <strong>{t.client}:</strong> {selectedProject.client[language] || selectedProject.client['gb']}
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center">
                        <FaCalendarAlt className="text-danger me-3" />
                        <div>
                          <strong>{t.timeline}:</strong> {selectedProject.year}
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center">
                        <FaClock className="text-danger me-3" />
                        <div>
                          <strong>{t.duration}:</strong> {selectedProject.duration[language] || selectedProject.duration['gb']}
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center">
                        <FaHardHat className="text-danger me-3" />
                        <div>
                          <strong>{t.scope}:</strong> {selectedProject.scope[language] || selectedProject.scope['gb']}
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center">
                        <FaBuilding className="text-danger me-3" />
                        <div>
                          <strong>{t.budget}:</strong> {selectedProject.budget[language] || selectedProject.budget['gb']}
                        </div>
                      </li>
                    </ul>
                    <div className="mt-3">
                      <h6 className="text-danger">{t.progress}</h6>
                      <div className="progress" style={{height: '10px'}}>
                        <div 
                          className={`progress-bar ${selectedProject.status === 'accelerated' ? 'bg-warning' : 'bg-danger'}`} 
                          role="progressbar" 
                          style={{width: `${selectedProject.progress}%`}}
                        ></div>
                      </div>
                      <div className="text-end mt-1">
                        <span className="text-muted">{selectedProject.progress}% {t.complete}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  className="btn btn-outline-secondary" 
                  onClick={handleCloseModal}
                >
                  {t.close}
                </button>
                <button className="btn btn-danger">
                  {t.requestInfo}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ongoing;